// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"S2-z","dimensionLabel":"T2-z","styleChooserControlWrapper":"U2-z","styleChooserControl":"V2-z","disabled":"W2-z","giftCard":"X2-z","styleChooserText":"Y2-z"};